<script lang="ts" setup>
  import { onMounted, onUnmounted } from 'vue';
  import type { GameConfig, PhaseLengthsRange, Range } from '../../../../shared/api/game.ts';
  import {
    changeSettings,
    type SettingsChange,
    settingsInSight,
    settingsSaveFailures,
  } from '../../model/settingsSaving.ts';
  import GameSettings from './GameSettings.vue';

  defineProps<{ config: GameConfig; roundsRange: Range; phaseLengthsRange: PhaseLengthsRange }>();
  const emit = defineEmits<{ saved: [] }>();

  onMounted(() => (settingsInSight.value = true));
  onUnmounted(() => (settingsInSight.value = false));

  const change = (settingChanged: SettingsChange) => changeSettings(settingChanged, () => emit('saved'));
</script>

<template>
  <GameSettings
    :config="config"
    :failures="settingsSaveFailures"
    :phase-lengths-range="phaseLengthsRange"
    :rounds-range="roundsRange"
    @change="change"
  />
</template>
